export default __webpack_public_path__ + "static/edsurge_pi_badge-02a339cc908667f9edeefb7cd3f9253b.png";